export const defaultPatientListSort = { sortBy: "recentActivity", sortDirection: "desc" };
export const defaultPatientListSortDirection = {
    recentActivity: "desc",
    name: "asc",
    dateOfBirth: "asc",
    expiry: "asc",
};
//# sourceMappingURL=patientList.js.map